export const PRIMARY_BLUE = () => '#00d0b2';

export const PRIMARY_GREEN = () => '#676767';
